module.exports = "/images/parking-gray.svg?bcca2a3d67913bdb8d95e2df11858e6a";